export function Sleep(timeoutMs: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, timeoutMs));
}

export class SynchronizationContext {
  private _lock?: Promise<void>;

  public async runAsyncTask<T>(taskProvider: () => Promise<T>): Promise<T> {
    if (this._lock) {
      // awaiting for the lock
      await this._lock;
    }
    // !!! dedicated 'if (this._lock)' check here as this._lock state may changed while awaiting
    if (this._lock) {
      // if it is set, someone else who was awaiting already acquired lock - so we need continue waiting recursively
      return this.runAsyncTask<T>(taskProvider);
    } else {
      // if unset - we could run the task
      const ret = taskProvider(); // acquire task to run
      this._lock = ret as Promise<void>; // !!! LOCK: this task is the new lock
      const result = await ret; // await task completion
      this._lock = undefined; // !!! UNLOCK: release lock
      return result;
    }
  }

  public async runTask<T>(taskProvider: () => T): Promise<T> {
    if (this._lock) {
      // awaiting for the lock
      await this._lock;
    }
    // !!! dedicated 'if (this._lock)' check here as this._lock state may changed while awaiting
    if (this._lock) {
      // if it is set, someone else who was awaiting already acquired lock - so we need continue waiting recursively
      return this.runTask<T>(taskProvider);
    } else {
      // if unset - we could run the task
      return taskProvider();
    }
  }
}
